export default "__VITE_ASSET__B$CZMOue__"